import { useState } from "react";
import { db } from "./firebase"; // ✅ FIXED PATH
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import "./AdminBlog.css";

export default function AdminBlog() {
  const [blog, setBlog] = useState({
    title: "",
    slug: "",
    content: ""
  });

  // 🔥 Auto generate slug
  const generateSlug = (text) => {
    return text
      .toLowerCase()
      .replace(/[^a-z0-9 ]/g, "")
      .replace(/\s+/g, "-");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (!blog.title || !blog.content) {
        alert("Please fill all fields");
        return;
      }

      const finalSlug = blog.slug || generateSlug(blog.title);

      await addDoc(collection(db, "blogs"), {
        title: blog.title,
        slug: finalSlug,
        content: blog.content,
        createdAt: serverTimestamp()
      });

      alert("Blog published ✅");

      // reset form
      setBlog({
        title: "",
        slug: "",
        content: ""
      });

    } catch (error) {
      console.error(error);
      alert("Error publishing blog ❌");
    }
  };

  return (
    <div className="admin-blog">
      <div className="admin-container">
        <h1>Create Blog</h1>

        <form onSubmit={handleSubmit} className="admin-form">
          <input
            value={blog.title}
            placeholder="Blog Title"
            onChange={(e) =>
              setBlog({
                ...blog,
                title: e.target.value,
                slug: generateSlug(e.target.value) // auto slug
              })
            }
          />

          <input
            value={blog.slug}
            placeholder="Slug (auto-generated)"
            onChange={(e) =>
              setBlog({ ...blog, slug: e.target.value })
            }
          />

          <textarea
            value={blog.content}
            placeholder="Write your blog..."
            rows={10}
            onChange={(e) =>
              setBlog({ ...blog, content: e.target.value })
            }
          />

          <button type="submit">Publish Blog 🚀</button>
        </form>
      </div>
    </div>
  );
}